import { useCallback, useEffect, useState } from "react";

/* ---------------------------------------------------------------
   Persists the open/closed state of a collapsible profile section
   to localStorage so it survives reloads.  Each section is keyed
   by a short stable string (e.g. "balance", "stats").  Keeps in
   sync across tabs via the "storage" event.
------------------------------------------------------------------ */
const PREFIX = "pj_section_";

function readStored(key, fallback) {
  try {
    const v = localStorage.getItem(PREFIX + key);
    if (v === "0") return false;
    if (v === "1") return true;
    return fallback;
  } catch (e) {
    return fallback;
  }
}

function writeStored(key, open) {
  try {
    localStorage.setItem(PREFIX + key, open ? "1" : "0");
  } catch (e) {}
}

export function useCollapsedSection(key, defaultOpen = true) {
  const [open, setOpen] = useState(() => readStored(key, defaultOpen));

  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === PREFIX + key) {
        setOpen(e.newValue === "1");
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, [key]);

  const toggle = useCallback(() => {
    setOpen((prev) => {
      const next = !prev;
      writeStored(key, next);
      return next;
    });
  }, [key]);

  return [open, toggle];
}
